import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CustomSlider from './CustomSlider';
import verified from '../assets/images/verified.svg';
import PostMeta from './PostMeta';
import drop_horz from '../assets/images/drop_horz.svg';
import heart_icon from '../assets/images/heart_icon.svg';
import heart_icon_fill from '../assets/images/heart_icon_fill.svg';
import tip_icon from '../assets/images/tip_icon.svg';
import comment_icon from '../assets/images/comment_icon.svg';
import bookmark_icon from '../assets/images/bookmark_icon.svg';
import bookmark_icon_fill from '../assets/images/bookmark_icon_fill.svg';
import empty_blue from '../assets/images/empty-feed.svg';
import loaderIcon from '../assets/images/loader.gif';
import config from '../config/config';
import PostDropdown from './PostDropdown';
import SubscribeButton from './SubscribeButton';
import UserMention from './UserMention';

const UserProfilePosts = ({ userId, onPostCountChange, filter, isCompactView }) => {
  const [posts, setPosts] = useState([]);
  const [currentUserDetails, setCurrentUserDetails] = useState(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [mediaCount, setMediaCount] = useState({}); 

// Function to fetch posts
  const fetchPosts = async (pageNum = 1) => {
    const token = localStorage.getItem('token');

    // Check if userId is valid
    if (!userId) {
      console.error('User ID is missing');
      return;
    }

    setLoading(true);
    try {
      // Log the userId for debugging
      console.log('Fetching posts for userId:', userId);

      // Fetch posts for the authenticated user
      const url = `${config.baseURL}/get-user-posts?user_id=${userId}&page=${pageNum}`;

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Log the API response for debugging
      console.log('Posts API response:', response.data);

      const { 
      posts: fetchedPosts = [], 
      total_posts, 
      total_media_posts, 
      total_image_posts, 
      total_video_posts, 
      total_posts_likes 
    } = response.data;

      // Merge new posts with existing posts, avoiding duplicates
      setPosts((prevPosts) => {
        const existingPostIds = new Set(prevPosts.map((post) => post.id));
        const newPosts = fetchedPosts.filter((post) => !existingPostIds.has(post.id));

        // Process posts to include any additional logic related to auth user
        const processedPosts = newPosts.map((post) => ({
          ...post,
          isAuthUserPost: post.is_auth_user_post, // Add this field from API response
        }));

        return [...prevPosts, ...processedPosts];
      });

      // Update hasMore state based on whether there are more posts to fetch
      setHasMore(fetchedPosts.length > 0);

      // Notify parent component about the total posts and media posts
      if (onPostCountChange) {
        onPostCountChange(total_posts, total_media_posts, total_image_posts, total_video_posts, total_posts_likes);
      }

      // Fetch current user details
      const userDetailsResponse = await axios.get(`${config.baseURL}/current-user-details`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const userDetails = userDetailsResponse.data.data;
      setCurrentUserDetails(userDetails);

      // Log current user details for debugging
      console.log('User details:', userDetails);

      // Update media count based on fetched posts (if needed in your app)
      updateMediaCount(fetchedPosts);

    } catch (error) {
      console.error('Error fetching posts:', error);
    } finally {
      setLoading(false);
    }
  };

 useEffect(() => {
    if (userId) {
      fetchPosts(); // Call fetchPosts once userId is available
    }
  }, [userId]);  

const updateMediaCount = (posts) => {
  posts.forEach(post => {
    if (post.type === 'paid') {
      const userPosts = post.user_posts || [];
      const images = userPosts.filter(media => media.media_type === 'image').length;
      const videos = userPosts.filter(media => media.media_type === 'video').length;

      setMediaCount(prevMediaCount => ({
        ...prevMediaCount,
        [post.id]: { images, videos }
      }));
    }
  });
};

 const handleScroll = () => {
    const scrollPosition = window.innerHeight + window.scrollY;
    const bottomPosition = document.documentElement.scrollHeight;

    if (scrollPosition >= bottomPosition - 100 && !loading && hasMore) {
      setPage(prevPage => {
        const nextPage = prevPage + 1;
        fetchPosts(nextPage);
        return nextPage;
      });
    }
  };

  useEffect(() => {
    fetchPosts();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [filter]);


  const getInitials = (name) => {
    const nameParts = name.split(' ');
    if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
    return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
  };

const getContentWithLinks = (content = '', mentions = []) => {
  // Ensure mentions is an array
  if (!Array.isArray(mentions)) {
    console.error('Invalid mentions parameter, expected an array.');
    return content;
  }
  if (!mentions.length) return content;
  let updatedContent = content;
  mentions.forEach(mention => {
    if (mention.user && mention.user.user_name) {
      const mentionText = `@${mention.user.user_name}`;
      const mentionLink = `/${mention.user.user_name}`;
      const regex = new RegExp(`(${mentionText})(?![^<]*>)`, 'g');
      updatedContent = updatedContent.replace(regex, `<a href="${mentionLink}">${mentionText}</a>`);
    } else {
      console.warn('Invalid mention object:', mention);
    }
  });

  return updatedContent;
};

  return (
    <div className="home_post_content user_post_content_by_user">
      {posts.length === 0 && !loading && !hasMore ? (
        <div className="post_content_block">                              
          <div className="no_feed">
            <img src={empty_blue} alt="" />
            <p className="no_list">No posts yet</p>
          </div>
        </div>
      ) : (
        <>
          {posts.map(post => (

           <div className="blog_post_box" key={post.id}>            

            <div className="blog_post_content">
                <div className="content_blog_box">
                  <div className="client-info d-flex">
                    <div className="client_info_left">
                      <div className="client-img">
                        <div className="lazy-container">
                          <a 
                            className={`user_pic_area ${post.user.user_name === currentUserDetails?.user.user_name && currentUserDetails?.user.status === 'active' ? 'user_online_status' : ''}`} 
                            href={`/${post.user.user_name}`}
                          >
                            {post.user.user_details.profile ? (
                              <img src={post.user.user_details.profile} alt={post.user.name} />
                            ) : (
                              <span>{getInitials(post.user.name)}</span>
                            )}
                          </a>
                        </div>
                      </div>
                      <div className="content">
                        <h6 className="name">
                          <a href={`/${post.user.user_name}`}>
                            {post.user.name}
                            <img className="image_margin_left" src={verified} alt="" />
                          </a>
                        </h6>
                        <span className="designation">
                          <a href={`/${post.user.user_name}`}>@{post.user.user_name}</a>
                        </span>
                      </div>
                    </div>
                    <div className="client_info_right time_with_drop"> 
                      <span className="post_time">
                        <a href={`/${post.id}/${post.user.user_name}`}>{post.created_at_human}</a>
                      </span>
                      <PostDropdown postId={post.id} userName={post.user.user_name} userId={post.user.id} authUser={post.isAuthUserPost} />
                    </div>
                  </div>
                  <p dangerouslySetInnerHTML={{ __html: getContentWithLinks(post.content, post.mentions) }} />
                </div>
              </div>
              {(post.is_auth_user_post || post.type !== 'paid' || post.purchase_status === 'purchased') && 
                 post.media.length > 0 && (
                  <CustomSlider
                    media={post.media.map((mediaItem) => ({
                      url: mediaItem.url,
                      isVideo: /\.(mp4|webm|ogg|avi|mov|wmv|flv|mkv)$/i.test(mediaItem.url),
                    }))}
                  />
              )}
             {post.type === 'paid' && 
             post.purchase_status !== 'purchased' &&
             !post.is_auth_user_post &&  (
                <div className="unlock_blog_post">
                  <div className="unlock_icon">
                    <svg
                      width={54}
                      height={54}
                      viewBox="0 0 54 54"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M36.6793 18.72V13.2C36.6793 8.11898 32.5603 4 27.4793 4C22.3983 4 18.2793 8.11898 18.2793 13.2V18.72"
                        stroke="#8A96A3"
                        strokeWidth="4.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M40.36 20.5601H14.6C12.0595 20.5601 10 22.6195 10 25.1601V45.4001C10 47.9406 12.0595 50.0001 14.6 50.0001H40.36C42.9005 50.0001 44.96 47.9406 44.96 45.4001V25.1601C44.96 22.6195 42.9005 20.5601 40.36 20.5601Z"
                        stroke="#8A96A3"
                        strokeWidth="4.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M27.4805 37.58V32.98"
                        stroke="#8A96A3"
                        strokeWidth="4.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <div className="unlock_price">${post.price} </div>
                  </div>
                  <div className="unlock_subscribe_btn">
                    <div className="media_wrap_paid">
                      <div className="media_count_left">
                        <div className="media_count">
                          <svg
                            width={54}
                            height={54}
                            viewBox="0 0 54 54"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.3158 41.3006H41.1197C41.873 41.3006 42.2756 40.4134 41.7795 39.8464L34.4309 31.448C34.1088 31.0799 33.548 31.0465 33.1845 31.3736L25.6712 38.1356C25.3346 38.4385 24.8227 38.4353 24.4899 38.1281L20.0343 34.0153C19.6738 33.6824 19.1103 33.7103 18.7843 34.077L13.6605 39.8413C13.1578 40.4068 13.5593 41.3006 14.3158 41.3006Z"
                              fill="#8A96A3"
                            />
                            <circle
                              cx="3.94569"
                              cy="3.94569"
                              r="3.94569"
                              transform="matrix(-1 0 0 1 23.7617 15.873)"
                              fill="#8A96A3"
                            />
                            <path
                              d="M48.314 7.98131V47.4382C48.314 47.9225 47.9215 48.315 47.4372 48.315H7.98034C7.49608 48.315 7.10352 47.9225 7.10352 47.4382V7.98131C7.10352 7.49706 7.49608 7.10449 7.98034 7.10449H47.4372C47.9215 7.10449 48.314 7.49706 48.314 7.98131Z"
                              stroke="#8A96A3"
                              strokeWidth="4.82251"
                              strokeLinecap="round"
                            />
                          </svg>
                          {post.total_images}
                        </div>
                        <div className="video_count media_count">
                          <svg
                            width={54}
                            height={54}
                            viewBox="0 0 54 54"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M36.8627 10.4512H5.8904C4.84636 10.4512 4 11.2975 4 12.3416V40.5492C4 42.7583 5.79086 44.5492 7.99999 44.5492H36.8627C39.0719 44.5492 40.8627 42.7583 40.8627 40.5492V14.4512C40.8627 12.242 39.0719 10.4512 36.8627 10.4512Z"
                              stroke="#8A96A3"
                              strokeWidth={5}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M51.0005 15.52L40.8633 23.8141V30.7259L51.0005 39.9416V15.52Z"
                              stroke="#8A96A3"
                              strokeWidth={5}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          {post.total_videos}
                        </div>
                      </div>
                      <div className="post_price_right">
                        ${post.price}
                        <svg
                          width={54}
                          height={54}
                          viewBox="0 0 54 54"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M36.6793 18.72V13.2C36.6793 8.11898 32.5603 4 27.4793 4C22.3983 4 18.2793 8.11898 18.2793 13.2V18.72"
                            stroke="#8A96A3"
                            strokeWidth="4.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M40.36 20.5601H14.6C12.0595 20.5601 10 22.6195 10 25.1601V45.4001C10 47.9406 12.0595 50.0001 14.6 50.0001H40.36C42.9005 50.0001 44.96 47.9406 44.96 45.4001V25.1601C44.96 22.6195 42.9005 20.5601 40.36 20.5601Z"
                            stroke="#8A96A3"
                            strokeWidth="4.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M27.4805 37.58V32.98"
                            stroke="#8A96A3"
                            strokeWidth="4.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <SubscribeButton postId={post.id} price={post.price} /> 
                  </div>
                </div>
              )}
              <div className="mentions_user_list">
                <UserMention postId={post.id} />
              </div>
              <PostMeta
                heart_icon={heart_icon}
                heart_icon_fill={heart_icon_fill}
                comment_icon={comment_icon}
                tip_icon={tip_icon}
                bookmark_icon={bookmark_icon}
                bookmark_icon_fill={bookmark_icon_fill}
                likesCount={post.likes_count} 
                commentsCount={post.comments_count} 
                postId={post.id}
                userHasLiked={post.userHasLiked}
                userId={post.user.id}              
              />
            </div>
          ))}
          {loading && hasMore && (
            <div className="load_more text-center">
              <img className="loading_icon top_loader_space" src={loaderIcon} alt="Loading..." />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default UserProfilePosts;
